import React, { useState } from 'react';
import { resendVerificationNotification } from '../api/auth';
import { useTranslation } from 'react-i18next';
import { getApiErrorMessage } from '../utils/apiError';

const ResendVerification = ({ token }) => {
  const [resendStatus, setResendStatus] = useState('');
  const [loading, setLoading] = useState(false); // ボタン連打防止用
  const { t } = useTranslation('resendVerification');
  const { t: tApi } = useTranslation('apiErrors');

  if (!token) return null;

  const handleResend = async () => {
    if (loading) return;

    setLoading(true);
    setResendStatus('');

    try {
      const response = await resendVerificationNotification(token);
      setResendStatus(response?.message || t('resent'));
    } catch (error) {
      setResendStatus(getApiErrorMessage(error, tApi));
    } finally {
      // 最低でも10秒間はボタンを押せないようにする
      setTimeout(() => {
        setLoading(false);
      }, 10000);
    }
  };

  return (
    <div style={{padding: '10px', marginBottom: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button onClick={handleResend} disabled={loading}>
          {loading ? t('sending') : t('resend')}
        </button>
      </div>
      {resendStatus && <p style={{ marginTop: '10px' }}>{resendStatus}</p>}
    </div>
  );
};

export default ResendVerification;
